import styled, { css } from "styled-components";
import { FlexColumnDiv, FlexRowDiv, FlexRowSpaceBetween } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { LightText } from "./HXMobilePage.styles";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { colors } from "healthex-common/colors";
import { LighterText } from "./HXDesktopPage.styles";
import Warning from "@mui/icons-material/Warning";
import CircularProgress from "@mui/material/CircularProgress";
import { HXButton } from "./HXButton";
export const ConsentPreviewViewParent = styled(FlexColumnDiv) `
    gap: 32px;
    align-self: stretch;
`;
export const AddJoinCommonPreviewItems = styled(FlexColumnDiv) `
    gap: 24px;
`;
export const AddJoinCommonPreviewItem = styled(FlexRowDiv) `
    justify-content: space-between;
    align-items: center;
`;
export const ItemName = styled.div `
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const ItemActions = styled(FlexRowDiv) `
    gap: 16px;
`;
export const DownloadSectionWrapper = styled(FlexColumnDiv) `
    gap: 24px;
    ${({ showBorderAndBackground }) => showBorderAndBackground &&
    css `
            border-radius: 4px;
            border: 1px solid ${colors.black_12};
            background: ${colors.white_main};
            padding: 24px;
        `}
`;
export const PreviewOrDownloadSection = styled(FlexColumnDiv) `
    gap: 24px;
`;
export const PreviewOrDownloadTitleAndText = styled.div `
    max-width: 1000px;
`;
export const PreviewOrDownloadTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const PreviewOrDownloadText = styled(LightText) ``;
export const PreviewButtons = styled(FlexRowDiv) `
    gap: 8px;
`;
export const ReadyStatus = styled(FlexColumnDiv) `
    white-space: initial; // undo nowrap set by data grid
    gap: 4px;
`;
export const ReadyStatusLine = styled(FlexRowDiv) `
    align-items: center;
    gap: 4px;
`;
export const ReadyIcon = styled(CheckCircle) `
    color: ${colors.forest_main};
    width: 16px;
    height: 16px;
`;
export const ReadyText = styled.div `
    color: ${colors.forest_main};
`;
export const ReadyGeneratedOnText = styled(LighterText) `
    font-size: ${fontSizes.TINY};
    white-space: pre-wrap;
`;
export const ErrorStatus = styled(FlexRowDiv) `
    align-items: center;
    gap: 4px;
    color: ${colors.tulip_main};
`;
export const ErrorIcon = styled(Warning) `
    width: 16px;
    height: 16px;
`;
export const PDFDownloadButtonCircularProgress = styled(CircularProgress) `
    color: ${colors.navy_main};
    width: 16px;
    max-width: 16px;
    min-width: 16px;
    height: 16px;
    max-height: 16px;
    min-height: 16px;
    margin-right: 4px;
`;
export const PDFDownloadStyledButton = styled(HXButton) ``;
export const NoShrinkButton = styled(HXButton) `
    flex-shrink: 0;
`;
export const ProjectManagerPreviewSection = styled(FlexRowSpaceBetween) `
    border-radius: 4px;
    border: 1px solid ${colors.navy_main};
    background: ${colors.navy_8};
    padding: 24px;
    align-items: center;
`;
export const PreviewTitleAndInfo = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const PreviewTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const PreviewInfo = styled(FlexRowDiv) `
    gap: 24px;
`;
export const PreviewInfoItem = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;

    & svg {
        width: 24px;
        height: 24px;
    }
`;
